var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImproveEfficiency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27502 61.875C6.27502 62.9375 7.13752 63.8125 8.21252 63.8125L55.8 63.875C56.8625 63.875 57.7375 63.0125 57.7375 61.9375V56.0875L6.28752 56.025V61.875H6.27502Z",
    fill: "#002C3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1875 17.2625H24.375V28.65H39.625V17.2625H44.8C45.8625 17.2625 46.7375 16.4 46.7375 15.325C46.7375 14.825 46.5375 14.35 46.2 13.9875L33.3875 0.7125C33.025 0.3375 32.525 0.125 32 0.125C31.475 0.125 30.975 0.3375 30.6125 0.7125L17.8 13.9875C17.2625 14.55 17.1125 15.375 17.4125 16.0875C17.7125 16.8 18.4125 17.2625 19.1875 17.2625Z",
    fill: "#47ADB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27502 32.5125V40.425L57.725 40.4875V32.575L6.27502 32.5125Z",
    fill: "#002C3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27502 52.1625L57.725 52.225V44.35L6.27502 44.2875V52.1625Z",
    fill: "#002C3E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImproveEfficiency);
export default __webpack_public_path__ + "static/media/ImproveEfficiency.b2fd6e418edd23fcbeb998e2b799003b.svg";
export { ForwardRef as ReactComponent };